import { render, staticRenderFns } from "./edit-vip.vue?vue&type=template&id=1ca12c36&scoped=true&"
import script from "./edit-vip.vue?vue&type=script&lang=js&"
export * from "./edit-vip.vue?vue&type=script&lang=js&"
import style0 from "./edit-vip.vue?vue&type=style&index=0&id=1ca12c36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca12c36",
  null
  
)

export default component.exports